import {
  VStack,
  useDisclosure,
  chakra,
  Center,
  HStack,
  Flex,
  Heading,
  Spacer,
  Image,
  useToast,
  Box,
  useMediaQuery,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react';
import { AccountContext } from 'components/AccountContext';
import ChildHeader from 'components/Dashboard/Main/ChildHeader';
import Loading from 'components/Loading';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TrocarPlano from '../../../images/TrocarPlano.svg';
import OutrasOpcoes from '../../../images/OutrasOpcoes.svg';
import Editar from '../../../images/editar.svg';
import Excluir from '../../../images/excluir.svg';
import FamiliaIcon from '../../../images/dashboard/familia.svg';
import { FaCircleInfo } from 'react-icons/fa6';
import Pet from './Modal/Pet';
import Dependentes from './Modal/Dependentes';
import DrawerTrocarPlano from './Modal/DrawerTrocarPlano';
import AvisoDependentes from '../Dependentes/AvisoDependentes';
import MainChildHeader from 'components/Dashboard/Main/MainChildHeader';
import BottomNavBar from 'components/BottomNavBar';
import { api } from 'api/api';
import { getAppTheme, userIsSubscriber } from 'components/Utils/theme';
import TrocarPlanoModal from './Modal/TrocarPlanoModal';
import Plano from 'components/Cadastro/Plano';
import { loadPlans } from 'api/plans';
import { Button } from '@chakra-ui/react';
import DeleteAssociado from './DeleteAssociado';

function Main() {
  const [minPlanValue, setMinPlanValue] = useState(null);
  const [familiaAnnualValue, setFamiliaAnnualValue] = useState(null);
  const [loadingMinValue, setLoadingMinValue] = useState(true);
  const modalAssociado = useDisclosure();
  useEffect(() => {
    async function fetchValues() {
      try {
        const plans = await loadPlans(user?.code_ibge);
        const mensalValues = plans
          .flatMap((p) => p.parcelas || [])
          .filter((parc) => parc.quantidade === 1)
          .map((parc) => Number(parc.min_valor))
          .filter((v) => !isNaN(v));
        setMinPlanValue(mensalValues.length > 0 ? Math.min(...mensalValues) : null);

        const familia = plans.find((p) => p.id === 29);
        if (familia) {
          const anual = familia.parcelas.find((parc) => parc.quantidade === 12);
          setFamiliaAnnualValue(anual ? Number(anual.min_valor) : null);
        } else {
          setFamiliaAnnualValue(null);
        }
      } catch (e) {
        setMinPlanValue(null);
        setFamiliaAnnualValue(null);
      } finally {
        setLoadingMinValue(false);
      }
    }
    fetchValues();
  }, []);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [valor, setValor] = useState([]);
  const { setPage, setUser, user, toastInadimplente } = useContext(AccountContext);
  const { id_contrato, descricao_plano, titular } = user;
  const [dependentes, setDependentes] = useState([]);
  const [dependentes_cancelados, setDependentesCancelados] = useState([]);
  const [restricao_dependente, setRestricaoDependente] = useState(true);
  const [pets, setPets] = useState([]);
  const [titular_dados, setTitular] = useState([]);
  const [refValorPlano, setRefValorPlano] = useState(false);
  const toast = useToast();
  const petDisclosure = useDisclosure();
  const trocarplanoDisclousure = useDisclosure();
  const disclosureDependentes = useDisclosure();
  const dependenteDisclosure = useDisclosure();
  const [showPlanoTrocadoToast, setShowPlanoTrocadoToast] = useState(false);
  const [simestralidade, setSimestralidade] = useState(12);
  const [deleteAssociado, setDeleteAssociado] = useState([]);
  const [taxa_remocao_dependente, setTaxaRemocaoDependente] = useState(null);
  function callToast(title, descricao, status) {
    toast({
      title: title,
      description: descricao,
      status: status,
      duration: 6000,
      isClosable: true,
      position: 'bottom',
      colorScheme: 'red',
      containerStyle: {
        paddingTop: '50px',
      },
    });
  }
  const [planoLoaded, setPlanoLoaded] = useState(user.id_plano ? 0 : null);
  const ENDPOINT =
    process.env.REACT_APP_ENVIRONMENT === 'production'
      ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
      : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;
  setPage('Assinaturas');
  let valorString = 0;
  const fetchValorPlano = async () => {
    const id_contrato = titular ? user?.id_contrato : user?.id_contrato_dependent?.paciente_contrato_id;
    const url = `${ENDPOINT}/clients/searchPlanoValue`;

    const response = await api(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ id_contrato }),
    });
    const postsData = await response.json();
    if (postsData.success !== true) {
      setError('Não foi possível encontrar os detalhes do seu contrato. Favor, entre em contato com o suporte');
      setLoading(false);
      return;
    }
    setValor(postsData?.valor);
    console.log('Valor do plano:', postsData?.valor);
    setTaxaRemocaoDependente(postsData);
    if (postsData?.valor_taxa !== null || postsData?.valor_taxa !== undefined) {
      setUser({ ...user, taxa_remocao_dependente: postsData?.valor_taxa });
    }
    setSimestralidade(Number(postsData?.simestralidade));
  };
  const fetchDependentes = async () => {
    const url = `${ENDPOINT}/client/dependents`;
    const response = await api(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ id_contrato: id_contrato, titularInQuery: false, paciente_id: user?.id_cliente_deovita }),
    });
    const postsData = await response.json();
    setDependentes(postsData.data);
    setLoading(false);
  };

  function addDays(date, days) {
    date.setDate(date.getDate() + days);
    return date;
  }

  const fetchDependentesCancelados = async () => {
    setLoading(true);
    const url = `${ENDPOINT}/client/dependentsCancelados`;
    const response = await api(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ id_contrato: id_contrato }),
    });
    const postsData = await response.json();
    if (postsData?.data?.length > 0) {
      const data_contrato_padrao = new Date(postsData?.data[0].data_cadastro);
      const hoje = new Date();
      const dataHoje = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());

      data_contrato_padrao.setUTCHours(0, 0, 0, 0);
      dataHoje.setUTCHours(0, 0, 0, 0);

      const diferencaDias = Math.floor((hoje - data_contrato_padrao) / (1000 * 60 * 60 * 24));
      setRestricaoDependente(diferencaDias >= 90 ? false : true);
    } else {
      setRestricaoDependente(false);
    }
    setLoading(false);
  };

  const fetchPets = async () => {
    const url = `${ENDPOINT}/client/pets`;
    const response = await api(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ id_contrato: user.id_contrato, paciente_id: user?.id_cliente_deovita }),
    });
    const postsData = await response.json();
    setLoading(false);
    setPets(postsData.data);
  };

  const fetchTitular = async () => {
    setLoading(true);
    const url = `${ENDPOINT}/clients/getTitularDados`;
    const response = await api(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ id_contrato_dependent: user?.id_contrato_dependent?.paciente_contrato_id, associado: user.id_cliente_deovita }),
    });
    const postsData = await response.json();
    setLoading(false);
    setTitular(postsData.data);
  };
  useEffect(() => {
    if (localStorage.getItem('plano_trocado_sucesso')) {
      if (trocarplanoDisclousure.isOpen) {
        trocarplanoDisclousure.onClose();
      }
      setShowPlanoTrocadoToast(true);
      localStorage.removeItem('plano_trocado_sucesso');
    }
    if (user.id_plano !== null && user.id_plano !== undefined) {
      fetchValorPlano();
    }
    fetchDependentes();
    fetchPets();
    fetchValorPlano();
    if (user.titular && user.id_plano !== undefined) {
      fetchDependentesCancelados();
    } else {
      setRestricaoDependente(false);
    }
    if (!user.titular && user.id_plano !== undefined) {
      fetchTitular();
    }
  }, []);

  function formatCPF(cpf) {
    const cpfRegex = /^(\d{3})(\d{3})(\d{3})(\d{2})$/;
    return cpf?.replace(cpfRegex, '$1.$2.$3-$4');
  }

  const refechValorPlano = (data) => {
    setRefValorPlano(data.success);
    setValor(data.valor);
  };

  useEffect(() => {
    if (user.id_plano !== null && user.id_plano !== undefined) {
      fetchValorPlano();
    }
  }, [refValorPlano]);

  function formatAniversario(aniversario) {
    const dataNascimento = new Date(aniversario);

    const dia = dataNascimento.getDate();
    const mes = dataNascimento.getMonth() + 1;
    const ano = dataNascimento.getFullYear();

    const dataAniversario = `${dia < 10 ? '0' : ''}${dia}/${mes < 10 ? '0' : ''}${mes}/${ano}`;

    return dataAniversario;
  }
  const assinante = userIsSubscriber(user);
  const useDependentes = dependentes.map((dependente, index) => {
    const arrName = dependente.nome.split(' ');
    const preposicoes = ['das', 'dos', 'des', 'da', 'do', 'de'];
    const nome = Array.isArray(arrName) ? arrName.filter((name, index) => index <= 1 && preposicoes.includes(name) === false).join(' ') : '';
    return (
      <>
        <HStack justify="space-between" w="100%" spacing={4} mt={index === 0 ? '1em' : ''}>
          <chakra.span fontSize="12" color={'#585858'}>
            {nome}
          </chakra.span>
          <HStack>
            <Image
              boxSize="15px"
              objectFit="cover"
              src={Editar}
              alt=""
              mr={'0.5em'}
              onClick={() => {
                navigate('/perfil/dependentes/editar', {
                  state: {
                    id: dependente.paciente_id,
                    dependente_id: dependente.paciente_contrato_dependente_id,
                    nome: dependente.nome,
                    cpf: dependente.cpf,
                    nascimento: dependente.nascimento,
                    cep: dependente.cep,
                    code_ibge: dependente.codigo_ibge,
                    logradouro: dependente.logradouro,
                    numero: dependente.numero,
                    bairro: dependente.bairro,
                    complemento: dependente.complemento,
                    municipio: dependente.municipio,
                    estado: dependente.estado,
                    fone: dependente.celular,
                    sexo: dependente.sexo,
                  },
                });
              }}
            />
            <Image
              boxSize="15px"
              objectFit="cover"
              src={Excluir}
              alt=""
              onClick={() => {
                if (user.id_plano === null || user.id_plano === undefined) {
                  setDeleteAssociado(dependente);
                  modalAssociado.onOpen();
                  return;
                }

                if (
                  user.id_plano &&
                  (taxa_remocao_dependente === null ||
                    taxa_remocao_dependente === undefined ||
                    !taxa_remocao_dependente ||
                    taxa_remocao_dependente === 0 ||
                    taxa_remocao_dependente === '0' ||
                    taxa_remocao_dependente === '0.00' ||
                    taxa_remocao_dependente === 0.0)
                ) {
                  toast({
                    render: () => (
                      <Box color="white" bg="#5AB2AE" p={3} borderRadius="md">
                        <Text fontWeight="bold">Importante</Text>
                        <Text>Não foi possível excluir o dependente. Entre em contato com o suporte</Text>
                      </Box>
                    ),
                    duration: 4000,
                    isClosable: true,
                    position: 'bottom',
                    containerStyle: {
                      paddingBottom: '5em',
                    },
                  });
                  return;
                }
                navigate('/perfil/dependentes/aviso-exclusao', {
                  state: { id: dependente.paciente_contrato_dependente_id, navigate_to: '/perfil/assinaturas', taxa_remocao_dependente: taxa_remocao_dependente },
                });
              }}
            />
          </HStack>
        </HStack>
        <Spacer border={'0.1px solid #f0f0f0'} />
      </>
    );
  });

  const usePets = pets.map((pet, index) => {
    const arrName = pet.nome.split(' ');
    const preposicoes = ['das', 'dos', 'des', 'da', 'do', 'de'];
    const nome = Array.isArray(arrName) ? arrName.filter((name, index) => index <= 1 && preposicoes.includes(name) === false).join(' ') : '';
    return (
      <>
        <HStack justify="space-between" w="100%" spacing={4} mt={index === 0 ? '1em' : ''}>
          <chakra.span fontSize="12" color={'#585858'}>
            {nome}
          </chakra.span>
          <Image
            boxSize="15px"
            objectFit="cover"
            src={Excluir}
            alt=""
            onClick={() => {
              if (user.id_plano === null || user.id_plano === undefined) {
                setDeleteAssociado(pet);
                modalAssociado.onOpen();
                return;
              }

              if (
                user.id_plano &&
                (taxa_remocao_dependente === null ||
                  taxa_remocao_dependente === undefined ||
                  !taxa_remocao_dependente ||
                  taxa_remocao_dependente === 0 ||
                  taxa_remocao_dependente === '0' ||
                  taxa_remocao_dependente === '0.00' ||
                  taxa_remocao_dependente === 0.0)
              ) {
                toast({
                  render: () => (
                    <Box color="white" bg="#5AB2AE" p={3} borderRadius="md">
                      <Text fontWeight="bold">Importante</Text>
                      <Text>Não foi possível excluir o pet. Entre em contato com o suporte</Text>
                    </Box>
                  ),
                  duration: 4000,
                  isClosable: true,
                  position: 'bottom',
                  containerStyle: {
                    paddingBottom: '5em',
                  },
                });
                return;
              }
              navigate('/perfil/dependentes/aviso-exclusao', {
                state: { id: pet.paciente_contrato_dependente_id, navigate_to: '/perfil/dependentes/processar-dados-assinatura' },
              });
            }}
          />
        </HStack>
        <Spacer border={'0.1px solid #f0f0f0'} />
      </>
    );
  });
  const [isLargeHeight] = useMediaQuery('(max-height: 667px)');
  var screenHeight = window.innerHeight;
  var screenWidth = window.innerWidth;
  const marginLeftValue = useBreakpointValue({ base: '2em', md: '-4em' });
  const headingMarginLeft = useBreakpointValue({ base: '0', md: isLargeHeight ? '-35%' : '-40' });
  const valorMarginLeft = useBreakpointValue({ base: '-7em', md: '-8.2em' });
  let data_parcela = '';
  if (user.qntdeParcelas?.countParcelas > 0) {
    data_parcela = user?.qntdeParcelas?.datasParcelas !== null ? new Date(user?.qntdeParcelas?.datasParcelas[0]) : null;
    if (data_parcela !== null) {
      const dia = user?.qntdeParcelas?.forma_pagamento === 13 ? 60 : 0;
      data_parcela.setDate(data_parcela?.getDate() + dia);
    }
  }

  const dataAtual = new Date();
  const clientePendente = user?.loggedIn && user?.qntdeParcelas?.countParcelas && user?.qntdeParcelas?.countParcelas > 0 && dataAtual >= data_parcela;
  return !loading ? (
    <>
      <ChildHeader />
      <DeleteAssociado disclosure={modalAssociado} associado={deleteAssociado} />
      <Pet disclosure={petDisclosure} />
      <Dependentes disclosure={dependenteDisclosure} />
      <TrocarPlanoModal disclosure={trocarplanoDisclousure} valor={valor?.length > 0 ? valor : '0.00'} simestralidade={simestralidade} />
      <AvisoDependentes disclosure={disclosureDependentes} />
      <VStack w={'100%'} overflowY="auto" maxHeight="calc(100vh - 200px)">
        <VStack alignItems="center" spacing={2.5} w={'100%'}>
          {assinante && user?.id_plano && (
            <>
              <Heading fontSize="16px" fontWeight={'bold'} color={'#585858'} mt={'1.5em'} ml={headingMarginLeft}>
                Dados Assinatura
              </Heading>

              <VStack bg={'#5AB2AE'} borderRadius={'0.8em'} w={'75%'} p={1}>
                <VStack alignItems="flex-start" spacing={1} w={'100%'}>
                  <chakra.p fontSize="16" display="flex" alignItems="center">
                    <chakra.span color={'#ffffff'} fontSize="16" marginRight="0.5em" textAlign="left">
                      Assinatura:
                    </chakra.span>
                    <chakra.span fontWeight="bold" color={'#ffffff'} fontSize="16" textAlign="left">
                      {user.titular
                        ? String(descricao_plano).charAt(0).toUpperCase() + String(descricao_plano).slice(1).toLowerCase()
                        : titular_dados?.plano}
                    </chakra.span>
                  </chakra.p>
                  <chakra.p fontSize="16" display="flex" alignItems="center">
                    <chakra.span color={'#ffffff'} fontSize="16" textAlign="left">
                      Valor:
                    </chakra.span>
                    <chakra.span fontWeight="bold" color={'#ffffff'} fontSize="16" ml="0.5em">
                      R${' '}
                      {Number(valor).toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </chakra.span>
                  </chakra.p>
                </VStack>
              </VStack>
            </>
          )}
        </VStack>
        {user.titular ||
          (titular_dados?.nome && (
            <>
              <Box w={'74%'}>
                <HStack justify="space-between" w="100%" mt={assinante ? '2em' : '1em'}>
                  <Heading fontSize="16" color={'#585858'} fontWeight={'bold'}>
                    Dados do {(assinante && user?.id_plano) || (!assinante && user?.id_plano) ? 'Titular' : 'Associado'}
                  </Heading>

                  <chakra.span
                    fontSize="14"
                    color={'white'}
                    bg={'#5AB2AE'}
                    borderRadius={'1em'}
                    padding={'0.3em'}
                    h={'1.9em'}
                    onClick={() => navigate('/perfil/dados-pessoais')}
                  >
                    Editar dados
                  </chakra.span>
                </HStack>
                <VStack align="left" mb={'1em'}>
                  <chakra.span fontSize="14" color={'#585858'}>
                    Nome Completo:{' '}
                  </chakra.span>
                  <chakra.span fontSize="12" color={'#585858'} fontWeight={'bold'}>
                    {' '}
                    {user.titular ? user?.name : titular_dados?.nome}{' '}
                  </chakra.span>
                </VStack>

                <HStack justify="space-between" w="100%">
                  <VStack align="left">
                    <chakra.span fontSize="14" color={'#585858'}>
                      CPF:{' '}
                    </chakra.span>
                    <chakra.span fontSize="12" color={'#585858'} fontWeight={'bold'}>
                      {' '}
                      {formatCPF(user.titular ? user.cpf : titular_dados?.cpf)}{' '}
                    </chakra.span>
                  </VStack>
                  <VStack align="left">
                    <chakra.span fontSize="14" color={'#585858'}>
                      Nascimento:{' '}
                    </chakra.span>
                    <chakra.span fontSize="12" color={'#585858'} fontWeight={'bold'}>
                      {' '}
                      {formatAniversario(user.titular ? user.data_aniv : titular_dados?.nascimento)}{' '}
                    </chakra.span>
                  </VStack>
                </HStack>
                <Spacer border={'1px solid #f0f0f0'} />
              </Box>
            </>
          ))}

        {!user.titular ? (
          <></>
        ) : (
          <>
            <Box w={'74%'}>
              <HStack justify="space-between" w="100%" mt={'1em'}>
                <Heading fontSize="16" color={'#585858'} fontWeight={'bold'}>
                  {(assinante && user?.id_plano) || (!assinante && user?.id_plano) ? 'Dependentes' : 'Associados'}
                </Heading>
                <Box display="inline-flex">
                  <Image
                    boxSize="15px"
                    objectFit="cover"
                    src={Editar}
                    alt=""
                    mr={'1.1em'}
                    onClick={() => {
                      if (!assinante && user.titular && dependentes.filter((d) => !d.pet).length >= 4) {
                        toast({
                          title: 'Importante',
                          description: `Você já atingiu o limite de 4 dependentes humanos associaddo a você.`,
                          status: 'warning',
                          duration: 4000,
                          isClosable: true,
                          position: 'bottom',
                          colorScheme: 'red',
                          containerStyle: {
                            paddingTop: '50px',
                          },
                        });
                        return;
                      }
                      if (restricao_dependente) {
                        callToast(
                          'Importante',
                          'Há menos de 90 dias, um dependente vinculado a você excluiu a conta. Você só poderá adicionar outro em 90 dias.',
                          'error',
                        );
                        return;
                      }
                      if (assinante) {
                        let limit = user.qtde_max_dependentes_total;
                        let limitIncluso = user.qtde_max_dependentes;
                        if (dependentes.length >= limitIncluso && dependentes.length < limit) {
                          disclosureDependentes.onOpen();
                        }
                        if (dependentes.length >= limit) {
                          toast({
                            title: 'Importante',
                            description: `Você já atingiu o limite de ${limit} dependentes`,
                            status: 'warning',
                            duration: 4000,
                            isClosable: true,
                            position: 'bottom',
                            colorScheme: 'red',
                            containerStyle: {
                              paddingTop: '50px',
                            },
                          });
                          return;
                        }
                        if (dependentes.length < limitIncluso) {
                          navigate('/perfil/dependentes/cadastro/', {
                            state: { navigate_to: '/perfil/assinaturas', id_contrato: user.id_contrato, extra: false },
                          });
                        }
                      }
                      if (!assinante) {
                        navigate('/perfil/dependentes/cadastro/', {
                          state: { navigate_to: '/perfil/assinaturas', id_contrato: user.id_contrato, extra: false },
                        });
                      }
                    }}
                  />
                  <FaCircleInfo
                    color="grey"
                    onClick={() => {
                      petDisclosure.onOpen();
                    }}
                  />
                </Box>
              </HStack>

              <VStack w={'100%'}>{useDependentes}</VStack>
            </Box>

            <Box w={'74%'}>
              {user?.titular && (
                <>
                  <HStack justify="space-between" w="100%" mt={'1em'}>
                    <Heading fontSize="16" color={'#585858'} fontWeight={'bold'}>
                      Pets
                    </Heading>
                    <Box display="inline-flex">
                      <Image
                        boxSize="15px"
                        objectFit="cover"
                        src={Editar}
                        alt=""
                        mr={'1.1em'}
                        onClick={() => {
                          if (!assinante && user.titular && pets.length >= 1) {
                            callToast('Importante', `Você já atingiu o limite de 1 pet gratuito incluso no seu plano`, 'warning');
                            return;
                          }
                          let limit = user.qtde_max_dependentes;
                          if (pets.length >= limit && (assinante || user?.id_plano)) {
                            callToast('Importante', `Você já atingiu o limite de ${limit} pets no seu plano`, 'warning');
                            return;
                          }
                          navigate('/perfil/dependentes/cadastro-pet/', {
                            state: {
                              navigate_to: '/perfil/assinaturas',
                              id_cliente_deovita: user.id_cliente_deovita,
                              id_contrato: user.id_contrato,
                            },
                          });
                        }}
                      />
                      <FaCircleInfo
                        color="grey"
                        onClick={() => {
                          dependenteDisclosure.onOpen();
                        }}
                      />
                    </Box>
                  </HStack>

                  <VStack w={'100%'}>{usePets}</VStack>
                </>
              )}
            </Box>
          </>
        )}
        <Box w={'74%'}>
          <Heading fontSize="16" fontWeight="bold" mb="1em" color={'#585858'} mt={'1em'}>
            Opções
          </Heading>
          {assinante && user?.titular && user?.id_forma_pagamento !== 13 && (
            <>
              <HStack
                align="left"
                spacing={4}
                onClick={() => {
                  if (user.qntdeParcelas?.countParcelas && user.qntdeParcelas?.countParcelas > 0 && dataAtual >= data_parcela) {
                    toastInadimplente(user.id_forma_pagamento, user.qntdeParcelas);
                    return;
                  }
                  trocarplanoDisclousure.onOpen();
                }}
              >
                <Image boxSize="20px" objectFit="cover" src={TrocarPlano} alt="" />
                <chakra.span fontSize="12" color={'#585858'}>
                  {' '}
                  Trocar plano{' '}
                </chakra.span>
              </HStack>
              <Spacer border={'0.1px solid #f0f0f0'} />
            </>
          )}

          <HStack
            align="left"
            mt={'1em'}
            spacing={4}
            onClick={() => navigate('/perfil/assinaturas/mais-opcoes', { state: { dependentes: dependentes, pet: pets } })}
          >
            <Image boxSize="20px" objectFit="cover" src={OutrasOpcoes} alt="" />
            <chakra.span fontSize="12" color={'#585858'}>
              {' '}
              Outras opções{' '}
            </chakra.span>
          </HStack>

          <Spacer border={'0.1px solid #f0f0f0'} />
        </Box>

        {!assinante && (
          <>
            <Box textAlign="center" alignItems="center" w="100%" display="flex" flexDirection="column" minH="100vh" pb={10}>
              <Box p={4} borderRadius="xl" m={4} maxW="500px" display="flex" flexDirection="column" alignItems="center" textAlign="center">
                <Image src={FamiliaIcon} alt="Emoji de dinheiro" width={60} mb={2} />

                <Text color="gray.700" fontSize="lg" mb={2}>
                  No{' '}
                  <Text as="span" fontWeight="bold" color="teal.600">
                    DeoVita
                  </Text>{' '}
                  você tem acesso a
                  <Text as="span" fontWeight="semibold">
                    {' '}
                    Pronto Atendimento 24h
                  </Text>
                  ,
                  <Text as="span" fontWeight="semibold">
                    {' '}
                    Pediatria Online 24h
                  </Text>{' '}
                  +12 especialidades.
                </Text>

                <Text color="gray.600">Além de um veterinário online para cuidar da saúde do seu amigo de quatro patas.</Text>
              </Box>

              <Box p={6} bg="white" borderRadius="2xl" boxShadow="lg" maxW="500px" w="90%" display="flex" flexDirection="column" alignItems="center">
                <Text bg="teal.50" color="teal.600" fontWeight="bold" px={4} py={1} borderRadius="full" fontSize="sm" mb={3}>
                  ⭐ Recomendado para sua família
                </Text>

                <Heading color="teal.600" fontSize="2xl" mb={2}>
                  Plano Família Anual
                </Heading>

                <Text color="gray.600" mb={3}>
                  Mais economia e proteção completa para todos.
                </Text>

                {loadingMinValue ? (
                  <Loading />
                ) : (
                  <Text fontSize="lg" color="gray.700" textAlign="center" whiteSpace="nowrap" display="block">
                    <chakra.span display="inline" whiteSpace="nowrap">
                      A partir de
                      <chakra.span as="span" fontWeight="bold" color="teal.500" fontSize="3xl" mx={2}>
                        {familiaAnnualValue
                          ? `12x R$ ${familiaAnnualValue.toLocaleString('pt-BR', {
                              minimumFractionDigits: 2,
                            })}`
                          : 'Indisponível'}
                      </chakra.span>
                      <br />
                      no plano anual
                    </chakra.span>
                  </Text>
                )}

                <Button
                  bg="#2A918A"
                  color="white"
                  mt={5}
                  _hover={{ bg: '#5AB2AE', transform: 'translateY(-2px)' }}
                  _active={{ bg: '#1F655D' }}
                  borderRadius="full"
                  px={8}
                  h="44px"
                  isLoading={loading}
                  onClick={() => navigate('/cadastro/plano')}
                  transition="all 0.2s ease"
                >
                  Ver outras opções de plano
                </Button>
              </Box>
            </Box>
          </>
        )}
      </VStack>

      <BottomNavBar />
    </>
  ) : (
    <>
      <ChildHeader /> <Loading />
    </>
  );
}

export default Main;
